// export const SET_OPEN_ID = 'SET_OPEN_ID'

export const SAVE_TOKEN='SAVE_TOKEN';
export const SAVE_USER='SAVE_USER';
export const SAVE_USER_TIME='SAVE_USER_TIME';
export const RECORD_USERINFO='RECORD_USERINFO';
export const SET_NAVMENUS='SET_NAVMENUS'
export const SAVE_TRACE = 'SAVE_TRACE'
export const SET_SYS_CONFIG='SET_SYS_CONFIG'
export const SET_API_TOKEN='SET_API_TOKEN'
export const SET_SYS_CONFIG_TIME='SET_SYS_CONFIG_TIME'

export const SET_PROVINCES='SET_PROVINCES'
export const SET_CITYS='SET_CITYS'
export const SET_DISTRICTS='SET_DISTRICTS'
export const SET_TOWN='SET_TOWN'

export const RECORD_GUESTINFO='RECORD_GUESTINFO'
export const SETPAGECACHE = 'SETPAGECACHE'

export const SETPAGECONFIG='SETPAGECONFIG'
export const SETPAGECONFIGDETAIL='SETPAGECONFIGDETAIL'

export const SETMAINTAIN='SETMAINTAIN'

export const SETSERVICEURL='SETSERVICEURL'

export const SAVEWAREHOUSE='SAVEWAREHOUSE'

export const SET_ORPHANSHOWTIME = 'SET_ORPHANSHOWTIME'